"use client";

import Image from "next/image";
import { MessageCircle } from "lucide-react";
import Link from "next/link";
import { useI18n } from "@/i18n/I18nProvider";

export default function ConciergeBanner() {
  const { t } = useI18n();
  return (
    <section className="mx-5 mt-3">
      <div className="relative min-h-[146px] rounded-2xl overflow-hidden bg-gradient-to-r from-[#EEF9F5] via-[#E4F6EF] to-[#D8F1E8]">
        {/* Concierge portrait, blended into the card on its left edge */}
        <div className="absolute right-0 top-0 h-full w-[46%]">
          <Image
            src="/images/concierge-woman.jpg"
            alt="ChinaCare+ medical concierge with headset"
            fill
            sizes="(max-width: 430px) 200px, 200px"
            className="object-cover object-[54%_6%]"
            style={{
              maskImage: "linear-gradient(90deg, transparent 0%, #000 26%)",
              WebkitMaskImage: "linear-gradient(90deg, transparent 0%, #000 26%)",
            }}
          />
        </div>

        <div className="relative z-10 flex flex-col justify-center px-4 py-4 w-[64%]">
          <h3 className="text-[17.5px] font-bold leading-[1.2] text-text-dark tracking-[-0.2px]">
            {t("Your Medical Concierge in China")}
          </h3>
          <p className="mt-1.5 text-[14px] leading-[1.4] text-text-dark/60">
            {t("From consultation to recovery, we are with you every step.")}
          </p>
          <Link href="/concierge" className="mt-2.5 w-fit">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary px-3.5 py-2 text-[13px] font-bold text-white active:bg-primary/85">
              {t("Chat with Concierge")}
              <MessageCircle size={13} strokeWidth={2.2} />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
